/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, InputNumber, message, Modal, notification, Select, Space, Table } from "antd";
import confirm from "antd/lib/modal/confirm";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import DataTable, { DataTableRef } from "../../common/components/DataTable";
import MainLayout from "../../common/components/MainLayout";
import { ActionResult, Query } from "../../common/hooks/useApi";
import useInfraccionesRadarAPI from "../../infracciones/hooks/useInfraccionesAPI";
import FiltroInfracciones, { FiltroInfraccionesRef } from "../../infracciones/components/FiltroInfracciones";
import useLoteConsultaAPI, { LoteConsulta } from "../useLoteConsultaAPI";
import { DatabaseOutlined, DownloadOutlined } from '@ant-design/icons';
import styled from "styled-components";
import { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";
import DataFilter from "../../common/components/DataFilter";
import CategoriasCodigoTags from "../../common/components/CategoriasCodigoTags";
import { FilterValue } from "antd/lib/table/interface";
import { useForm } from "antd/lib/form/Form";
import useUsuariosAPI, { Usuario } from "../../usuarios/useUsuariosAPI";

const LocalQueryContainer = styled.div`
display: flex;
gap: 5px;
`;

export default () => {
    const api = useLoteConsultaAPI();
    const renombradoresApi = useUsuariosAPI();
    const refTable = useRef<DataTableRef>(null!);
    const [ nombreFilterForm ] = Form.useForm();
    const apiInfracciones = useInfraccionesRadarAPI();
    const [total, setTotal] = useState<number>();
    const [query, setQuery] = useState<Query>({});
    const [loading, setLoading] = useState(false);
    const [maxAntiguedad, setMaxAntiguedad] = useState<number>();
    const [loadingLocalTitulares, setLoadingLocalTitulares] = useState<boolean>()
    const filtroInfraccionesRef = useRef<FiltroInfraccionesRef>(null);
    const [unidadesProdSeleccionadas, setUnidadesProdSeleccionadas] = useState<any>([])
    const [unidadesProdNombres, setUnidadesProdNombres] = useState<any>([])
    const [ modalAsignacion, setModalAsignacion ] = useState<boolean>(false);
    const [ modalAsignacionLote, setModalAsignacionLote ] = useState<LoteConsulta>();
    const [ renombradoresResponse, setRenombradoresResponse ] = useState<ActionResult<Usuario[]>>();
    const [ idRenombrador, setIdRenombrador ] = useState<number>();
    const [ form ] = useForm();

    const getCantidadLocalTitulares = async (newQuery?: Query, ongoingQuery?: boolean, newMaxAntiguedad?: number) => {
        setLoadingLocalTitulares(true);
        const totalCantidadLocal = (await api.queryCantidadLocalTitulares(newQuery ?? query, ongoingQuery ? newMaxAntiguedad : maxAntiguedad, ongoingQuery))?.data?.value;
        //@ts-ignore
        const totalLocalCantidad = totalCantidadLocal?.value        
        setLoadingLocalTitulares(false);
        return totalLocalCantidad;
    }

    const localQuery = async (newQuery?: Query, ongoingQuery?: boolean, newMaxAntiguedad?: number) => {
        let cantidadTitulares = await getCantidadLocalTitulares(newQuery, ongoingQuery, newMaxAntiguedad);

        if (cantidadTitulares > 0) {
            confirm({
                okText: "Aceptar",
                cancelText: "Cancelar",
                title: `¿Realizar consulta local?
                Se encontró un total de ${cantidadTitulares} titulares
                `,
                /*
                title: `¿Consultar ${total! > 1 ? 'patentes' : 'patente'} localmente?`,
                content: `Se consultaran ${total} ${total! > 1 ? 'infracciones' : 'infraccion'}`,*/
                onOk: async () => {
                    setLoading(true);

                    notification.info({ message: "Consultando localmente..." });
                    let response = await api.queryExistingTitulares(newQuery ?? query, ongoingQuery ? newMaxAntiguedad : maxAntiguedad, ongoingQuery, unidadesProdNombres);                    
                    if (!response.error) {
                        notification.success({ message: "Consulta local enviada correctamente" });
                    }
                    else {
                        notification.error({ message: "Error al realizar la consulta local" });
                        return;
                    }

                    await filtroInfraccionesRef.current?.loadTotal();
                    await refTable.current.loadItems();

                    setLoading(false);
                }
            })
        } else {
            Modal.confirm({
                okCancel: false,
                type: "info",
                onOk: () => { },
                okText: "Aceptar",
                title: `No hay titulares que cumplan las condiciones`,
            })
        }


    };

    const generateQueryFile = (newQuery?: Query, ongoingQuery?: boolean) => {
        confirm({
            okText: "Aceptar",
            cancelText: "Cancelar",
            title: `¿Generar archivo de consulta?`,
            /*
            title: `¿Generar archivo de consulta para ${total! > 1 ? 'patentes' : 'patente'}?`,
            content: `Se consultaran ${total} ${total! > 1 ? 'infracciones' : 'infraccion'}`,*/
            onOk: async () => {
                setLoading(true);

                notification.info({ message: "Generando archivo de consulta..." });
                const response = await api.queryTitulares(newQuery ?? query, ongoingQuery, unidadesProdNombres);

                if (!response.data?.value) {
                    notification.warning({ message: "No hay patentes para consultar" });
                    return;
                }

                const blobUrl = window.URL.createObjectURL(new Blob([response.data!.value.blob]));
                const link = document.createElement('a');
                link.href = blobUrl;
                link.setAttribute('download', response.data!.value.filename);
                document.body.appendChild(link);
                link.click();

                if (!response.error) {
                    notification.success({ message: "Archivo de consulta generado correctamente" });
                }
                else {
                    notification.error({ message: "Error al generar archivo de consulta" });
                }

                await filtroInfraccionesRef.current?.loadTotal();
                await refTable.current.loadItems();

                setLoading(false);
            }
        })

    };

    const ConsultaExternaPatentes = (loteConsultaId:number) => {
        Modal.confirm({
            okText: "Aceptar",
            cancelText: "Cancelar",
            title: `¿Quiere realizar la consulta externa a INSIDER?`,
            content:'Esto tiene un costo por patente estipulado por el proveedor externo consultado...',
            onOk: async () => {
                setLoading(true);

                const response = await api.consultaExterna(loteConsultaId, 'INSIDER')
                console.log(response)

                await filtroInfraccionesRef.current?.loadTotal();
                await refTable.current.loadItems();
                setLoading(false);
            }
        })

    };

    useEffect(() => {
        if (unidadesProdSeleccionadas.length === 0) {
            return;
        }
        const unidadesProduccionNombres = unidadesProdSeleccionadas.map((unidad: UnidadProduccion) => unidad.Nombre);
        setUnidadesProdNombres(unidadesProduccionNombres)
    }, [unidadesProdSeleccionadas]);

    useEffect(() => {
        renombradoresApi
            .list({ $filter: ["Role/Nombre eq 'Renombrador'"], $orderby: ["Apellido desc"] })
            .then(setRenombradoresResponse);
    }, []);

    const generateFilters = (filters: Record<string, FilterValue | null>) => {    
        return [
          filters?.UnidadesProdNombre != null ? `contains(UnidadesProdNombre, '${filters!.UnidadesProdNombre[0]}')` : "",
        ];    
    };

    return (
        <MainLayout>
            <Space size={"large"} direction="vertical">
                <FiltroInfracciones
                    ref={filtroInfraccionesRef}
                    count={apiInfracciones.getConsultaPendienteCount}
                    onChange={(query) => {
                        setQuery(query);
                    }}
                    onChangeCount={(count) => {
                        setTotal(count);
                    }}
                    onChangeLoading={(loading) => {
                        setLoading(loading);
                    }}
                    onChangeUnidadesProd={(unid) => setUnidadesProdSeleccionadas(unid)}
                >
                    <LocalQueryContainer>
                        <Form.Item style={{ marginBottom: 0 }} label="Antigüedad máxima del titular (días)">
                            <InputNumber
                                onChange={(value) => setMaxAntiguedad(value !== null ? value : undefined)}
                                min={0}
                            />
                        </Form.Item>
                        <Button loading={loadingLocalTitulares} onClick={() => localQuery()} type="primary" disabled={(total ?? 0) == 0} icon={<DatabaseOutlined />}>Consulta local</Button>
                    </LocalQueryContainer>
                    <Button loading={loading} onClick={() => generateQueryFile()} type="primary" disabled={(total ?? 0) == 0} icon={<DownloadOutlined />}>Generar archivo</Button>
                </FiltroInfracciones>
                <Modal
                    afterClose = { async () => await refTable.current.loadItems() }
                    title = { `Asignar infracciones en Estado 'Consultando' del lote N° ${modalAsignacionLote?.NroLote}` }
                    open = { modalAsignacion }
                    onCancel = { () => { setModalAsignacion(false) } }
                    cancelText = "Cancelar"
                    okText = "Asignar renombrador"
                    onOk = { async () => {
                        setModalAsignacion(true);
                        try {
                            const response = await api.limpiarConsultando(modalAsignacionLote!.NroLote, idRenombrador!);
                            if (response.error || response.data?.value.value === false || modalAsignacionLote?.CantidadInfraccionesConsultando === 0) throw new Error();
                            message.success(`Infracciones asignadas correctamente.`);
                        } catch (error) {
                            message.error(`Error al asignar las infracciones al Renombrador seleccionado.`);
                        }
                        setModalAsignacion(false);
                        } 
                    }
                    key = { modalAsignacionLote?.Id }                    
                    >
                        <Form.Item>
                            <p>Cantidad de infracciones: { modalAsignacionLote?.CantidadInfraccionesConsultando }</p>
                        </Form.Item>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            name = "RenombradorId"
                            required
                            label = "Renombrador">
                            <Select
                                showSearch
                                optionFilterProp = "children"
                                loading = { !renombradoresResponse }
                                allowClear
                                onChange = { (e) => setIdRenombrador(e) }
                                >
                                { renombradoresResponse?.data?.value.map(usuario => <Select.Option value={usuario.Id} key={usuario.Id}>{usuario.Apellido}, {usuario.Nombre}</Select.Option>) }
                            </Select>
                        </Form.Item>
                </Modal>

            </Space>
            <DataTable<LoteConsulta, LoteConsulta>
                ref={refTable}
                list={api.list}
                delete={async (id) => {
                    const response = await api.delete(id);
                    await refTable.current.loadItems();
                    return response;
                }}
                deleteMultipleAction
                defaultSortOrder={"NroLote desc"}
                selectionType='checkbox'
                itemActions={[

                    {
                        key: 'txt-pendientes',
                        label: 'Descargar .txt pendientes',
                        action: (item) => generateQueryFile({ $filter: [`LoteConsultaId eq ${item.NroLote}`] }, true),
                        //checkDisabled: (selectedItems, currentIndex, items?) => (items?.at(currentIndex)?.CantidadInfraccionesConsultando ?? 0) == 0
                    },
                    {
                        key: 'local-pendientes',
                        label: 'Consulta local pendientes',
                        action: (item) => localQuery({ $filter: [`LoteConsultaId eq ${item.NroLote}`] }, true),
                        //checkDisabled: (selectedItems, currentIndex, items?) => (items?.at(currentIndex)?.CantidadInfraccionesConsultando ?? 0) == 0
                    },
                    {
                        key: 'descargar-csv',
                        label: 'Descargar .csv',
                        action: (item) => api.downloadCsv({ $filter: [`LoteConsultaId eq ${item.NroLote}`] })
                    },
                    {
                        key: 'consulta-externa',
                        label:'Consulta externa de patentes',
                        action: (item) => ConsultaExternaPatentes(item.NroLote)
                    },
                    {
                        key: 'limpiar-consultando',
                        label: 'Pasar Consultando a Pendiente',
                        action: (item) => {
                            if(item.CantidadInfraccionesConsultando == 0)
                            {
                                message.info('No hay infracciones en estado CONSULTANDO');
                                return;
                            }
                            setModalAsignacionLote(item)
                            setModalAsignacion(true)
                        }
                    }
                ]}
                deleteItemAction
                title={"Lotes de consulta"}
                generateFilters={ generateFilters }
                defaultPageSize={5}

            >
                <Table.Column<LoteConsulta>
                    width={`20%`}
                    title="Fecha"
                    dataIndex={"FechaHora"}
                    render={(value, record, index) => moment(value).format("DD/MM/YYYY HH:mm")}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`20%`}
                    title="Número"
                    defaultSortOrder={'descend'}
                    dataIndex={"NroLote"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`5%`}
                    title="Infracciones"
                    dataIndex={"CantidadInfracciones"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`15%`}
                    title="Consultadas"
                    dataIndex={"CantidadInfraccionesConsultadas"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`5%`}
                    title="Consultando"
                    dataIndex={"CantidadInfraccionesConsultando"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`5%`}
                    title="Verificadas"
                    dataIndex={"CantidadInfraccionesVerificadas"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                    width={`5%`}
                    title="Descartadas"
                    dataIndex={"CantidadInfraccionesDescartadas"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<LoteConsulta>
                        width={`20%`}
                        sorter
                        dataIndex={'UnidadesProdNombre'}
                        title="Unidad de producción"
                        render={(val, record) => (
                            <div style={{ textAlign: 'center' }}>
                              {record.UnidadesProdNombre
                                ? record.UnidadesProdNombre
                                : "-"}
                            </div>
                          )}
                          filterDropdown={(props) => {
                            return (
                                <DataFilter filterDropdownProps = {props} form = { nombreFilterForm } >
                                    <Form.Item name = {"UnidadesProdNombre"} style = {{ marginBottom: 10 }}>
                                        <Input placeholder = 'Unidad de producción...'></Input>
                                    </Form.Item>
                                </DataFilter>
                            );
                            }
                        }
                />

                <Table.Column<LoteConsulta>
                        width={`15%`}
                        dataIndex={"CategoriasCodigo"}
                        title="Categorías"
                        render={(val, record) => <CategoriasCodigoTags categoriasCodigo={record.CategoriasCodigo} />}
                />
            </DataTable>
        </MainLayout>
    );
}